module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_08.f3a6b0d1.jpg";